export enum OptimizerView {
    Data = "Data",
    Trajectory = "Trajectory",
    d = Data,
    t = Trajectory,
    NotDefined = ""
}

export function GetOptimizerView(s: string):OptimizerView{
    switch(s.toLowerCase()){
        case "data":
        case "d":
            return OptimizerView.Data;
        case "trajectory":
        case "t":
            return OptimizerView.Trajectory;        
        case "notdefined":
            return OptimizerView.NotDefined;
        default:
            return OptimizerView.NotDefined
    }
}